module.exports = __webpack_public_path__ + "img/morningstar.d253ad9b.png";